import React, { Component } from "react";
import Select from "react-select";
import Switch from "@material-ui/core/Switch";
import EncuestaTipo1 from "./EncuestaTipo1";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class VisitaGrupo1 extends Component {
  render() {
    return (
      <>
        <div>
          <h5>
            {this.props.state.tipo_encuesta !== "3" ? "1." : ""} DATOS GENERALES
            DEL ESTABLECIMIENTO Y LA INSPECCIÓN
          </h5>

          <fieldset className="panel">
            <legend>A) Datos generales</legend>

            <div className="container">
              <div className="row">
                {this.props.state.establecimiento_registrado ? (
                  <div className="col-lg-11">
                    <div className="form-group">
                      <label htmlFor="razon_social">
                        Razón social del establecimiento:{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      {/* <Select
                    id="razon_social"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    onChange={(e) =>
                      this.props.component.handleRazonSocialChange(e)
                    }
                    theme="neutral40"
                    options={this.props.state.establecimientos}
                    getOptionLabel={(establecimiento) =>
                      establecimiento.razon_social
                    }
                    getOptionValue={(establecimiento) => establecimiento.id}
                  /> */}
                      <select
                        name="razon_social"
                        id="razon_social"
                        onChange={(e) =>
                          this.props.component.handleRazonSocialChange(e)
                        }
                        value={this.props.state.establecimiento_id}
                        className="form-control"
                      >
                        <option value="" disabled>
                          Seleccione
                        </option>
                        {this.props.state.establecimientos.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.razon_social}
                          </option>
                        ))}
                      </select>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="razon_social-error"
                      ></div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="razon_social">
                          Razón social del establecimiento:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          value={
                            this.props.state.razon_social != null
                              ? this.props.state.razon_social
                              : ""
                          }
                          name="razon_social"
                          onChange={(e) =>
                            this.props.component.handleRazonSocialTextoChange(e)
                          }
                          className="form-control"
                          id="razon_social"
                          placeholder="Razón social"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="razon_social-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="form-group">
                        <label htmlFor="tipo_establecimiento">
                          Tipo de establecimiento:{" "}
                          <span className="text-danger"> *</span>
                        </label>

                        <select
                          name="tipo_establecimiento"
                          id="tipo_establecimiento"
                          onChange={(e) =>
                            this.props.component.handleTipoEstablecimientoChange(
                              e
                            )
                          }
                          value={
                            this.props.state.tipo_establecimiento != null
                              ? this.props.state.tipo_establecimiento
                              : ""
                          }
                          className="form-control"
                        >
                          <option value="" disabled>
                            Seleccione
                          </option>
                          {this.props.state.cat_tipo_establecimiento.map(
                            (option) => (
                              <option key={option.id} value={option.id}>
                                {option.descripcion.toUpperCase()}
                              </option>
                            )
                          )}
                        </select>
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="tipo_establecimiento-error"
                        ></div>
                      </div>
                    </div>
                  </>
                )}
                <div className="col-lg-1">
                  <div className="form-group">
                    <label htmlFor="establecimiento_registrado">
                      Registrado:
                    </label>
                    <br />
                    <Switch
                      className="establecimiento_registrado"
                      checked={this.props.state.establecimiento_registrado}
                      name="establecimiento_registrado"
                      onChange={(e) =>
                        this.props.component.handleEstablecimientoRegistradoChange(
                          e
                        )
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="actividad">
                      Actividad: <span className="text-danger"> *</span>
                    </label>

                    <select
                      name="actividad_id"
                      id="actividad_id"
                      onChange={(e) =>
                        this.props.component.handleActividadChange(e)
                      }
                      value={this.props.state.actividad_id}
                      className="form-control"
                    >
                      <option value="" disabled>
                        Seleccione
                      </option>
                      {this.props.state.cat_actividades.map((option) => (
                        <option
                          key={option.id}
                          value={option.id}
                          data-folio-licencia={option.folio_licencia}
                        >
                          {option.descripcion.toUpperCase()}
                        </option>
                      ))}
                    </select>
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="actividad_id-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group">
                    <label htmlFor="licencia_establecimiento">
                      Licencia de establecimiento:{" "}
                      <span className="text-danger campo-obligatorio"> *</span>
                    </label>
                    <input
                      type="text"
                      value={
                        this.props.state.licencia_establecimiento != null
                          ? this.props.state.licencia_establecimiento
                          : ""
                      }
                      onChange={(e) =>
                        this.props.component.handleLicenciaEstablecimientoChange(
                          e
                        )
                      }
                      name="licencia_establecimiento"
                      readOnly
                      className="form-control"
                      id="licencia_establecimiento"
                      placeholder="Licencia de establecimiento"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="licencia_establecimiento-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group">
                    <label htmlFor="folio_manual">Folio manual: </label>
                    <input
                      type="text"
                      value={
                        this.props.state.folio_manual != null
                          ? this.props.state.folio_manual
                          : ""
                      }
                      onChange={(e) =>
                        this.props.component.handleFolioManualChange(e)
                      }
                      name="folio_manual"
                      className="form-control"
                      id="folio_manual"
                      placeholder="Folio manual"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="direccion">
                      Dirección: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      value={this.props.state.direccion}
                      readOnly
                      onChange={(e) =>
                        this.props.component.handleDireccionChange(e)
                      }
                      name="direccion"
                      className="form-control"
                      id="direccion"
                      placeholder="Dirección del establecimiento"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="direccion-error"
                    ></div>
                  </div>
                </div>
                {this.props.state.establecimiento_registrado ? (
                  this.props.state.nombreMunicipio !== null &&
                  this.props.state.nombreDepartamento !== null ? (
                    <>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="departamento_id">
                            Departamento:{" "}
                            <span className="text-danger"> *</span>
                          </label>

                          <input
                            type="text"
                            name="departamento_id"
                            readOnly
                            value={
                              this.props.state.nombreDepartamento != null
                                ? this.props.state.nombreDepartamento.toUpperCase()
                                : ""
                            }
                            className="form-control"
                            id="departamento_id"
                            placeholder="Departamento"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="departamento_id-error"
                          ></div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="municipio_id">
                            Municipio: <span className="text-danger"> *</span>
                          </label>

                          <input
                            type="text"
                            name="municipio_id"
                            readOnly
                            value={
                              this.props.state.nombreMunicipio != null
                                ? this.props.state.nombreMunicipio.toUpperCase()
                                : ""
                            }
                            className="form-control"
                            id="municipio_id"
                            placeholder="Municipio_id"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="municipio_id-error"
                          ></div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="pais">
                          País: <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="text"
                          name="nombrePais"
                          readOnly
                          value={
                            this.props.state.nombrePais != null
                              ? this.props.state.nombrePais.toUpperCase()
                              : ""
                          }
                          className="form-control"
                          id="nombrePais"
                          placeholder="País"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="nombrePais-error"
                        ></div>
                      </div>
                    </div>
                  )
                ) : this.props.state.tipo_establecimiento === "1" ||
                  this.props.state.tipo_establecimiento === "3" ? (
                  <>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="departamento">
                          Departamento: <span className="text-danger"> *</span>
                        </label>

                        <select
                          name="departamento_id"
                          id="departamento_id"
                          onChange={(e) =>
                            this.props.component.handleDepartamentoChange(e)
                          }
                          value={
                            this.props.state.departamento_id != null
                              ? this.props.state.departamento_id
                              : ""
                          }
                          className="form-control"
                          placeholder="Seleccione"
                        >
                          <option value="" disabled>
                            Seleccione
                          </option>
                          {this.props.state.locations.departamentos.map(
                            (dep) => (
                              <option key={dep.id} value={dep.id}>
                                {dep.name.toUpperCase()}
                              </option>
                            )
                          )}
                        </select>
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="departamento_id-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="municipio_id">
                          Municipio: <span className="text-danger"> *</span>
                        </label>

                        <select
                          name="municipio_id"
                          id="municipio_id"
                          onChange={(e) =>
                            this.props.component.handleMunicipioChange(e)
                          }
                          value={
                            this.props.state.municipio_id != null
                              ? this.props.state.municipio_id
                              : ""
                          }
                          className="form-control"
                          placeholder="Seleccione"
                        >
                          <option value="" disabled>
                            Seleccione
                          </option>
                          {this.props.state.municipios.map((mun) => (
                            <option key={mun.id} value={mun.id}>
                              {mun.name.toUpperCase()}
                            </option>
                          ))}
                        </select>
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="municipio_id-error"
                        ></div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="pais">
                        País: <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="nombrePais"
                        id="nombrePais"
                        onChange={(e) =>
                          this.props.component.handlePaisChange(e)
                        }
                        value={this.props.state.pais_id}
                        className="form-control"
                      >
                        <option value="" disabled>
                          Seleccione
                        </option>
                        {this.props.state.cat_paises.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="nombrePais-error"
                      ></div>
                    </div>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-lg-3">
                  <div className="form-group">
                    <label htmlFor="latitud">
                      Latitud: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      step="any"
                      value={
                        this.props.state.latitud != null
                          ? this.props.state.latitud
                          : ""
                      }
                      onChange={(e) =>
                        this.props.component.handleLatitudChange(e)
                      }
                      name="latitud"
                      readOnly
                      className="form-control"
                      id="latitud"
                      placeholder="Latitud"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="latitud-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group">
                    <label htmlFor="longitud">
                      Longitud: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      step="any"
                      value={
                        this.props.state.longitud != null
                          ? this.props.state.longitud
                          : ""
                      }
                      onChange={(e) =>
                        this.props.component.handleLongitudChange(e)
                      }
                      name="longitud"
                      readOnly
                      className="form-control"
                      id="longitud"
                      placeholder="Longitud"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="longitud-error"
                    ></div>
                  </div>
                </div>
                <div
                  className={
                    this.props.state.tipo_encuesta === "3"
                      ? "col-lg-3"
                      : "col-lg-6"
                  }
                >
                  <div className="form-group">
                    <label htmlFor="folio_establecimiento">
                      Código del establecimiento:{" "}
                      <span className="text-danger campo-obligatorio"> *</span>
                    </label>
                    <input
                      type="text"
                      onChange={(e) =>
                        this.props.component.handleFolioEstablecimientoChange(e)
                      }
                      name="folio_establecimiento"
                      value={
                        this.props.state.folio_establecimiento != null
                          ? this.props.state.folio_establecimiento
                          : ""
                      }
                      className="form-control"
                      readOnly
                      id="folio_establecimiento"
                      placeholder="Código del establecimiento"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="folio_establecimiento-error"
                    ></div>
                  </div>
                </div>
                {this.props.state.tipo_encuesta === "3" ? (
                  <div className="col-lg-3">
                    <div className="form-group">
                      <label htmlFor="propietario">
                        Propietario: <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="propietario"
                        value={
                          this.props.state.propietario != null
                            ? this.props.state.propietario
                            : ""
                        }
                        onChange={(e) =>
                          this.props.component.handlePropietarioChange(e)
                        }
                        className="form-control"
                        id="propietario"
                        placeholder="Propietario"
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="propietario-error"
                      ></div>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="telefono">
                      Teléfono: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="number"
                      step="1"
                      min="0"
                      value={
                        this.props.state.telefono != null
                          ? this.props.state.telefono
                          : ""
                      }
                      name="telefono"
                      pattern={
                        this.props.state.tipo_establecimiento === "1" ||
                        this.props.state.tipo_establecimiento === "3"
                          ? "[0-9]{4}[0-9]{4}"
                          : "[0-9]+"
                      }
                      maxLength={
                        this.props.state.tipo_establecimiento === "1" ||
                        this.props.state.tipo_establecimiento === "3"
                          ? "8"
                          : "30"
                      }
                      onInput={(e) => this.props.component.maxLengthCheck(e)}
                      onChange={(e) =>
                        this.props.component.handleTelefonoChange(e)
                      }
                      className="form-control"
                      id="telefono"
                      placeholder="Teléfono"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="telefono-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="correo_electronico">
                      Correo electrónico:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="email"
                      name="correo_electronico"
                      value={
                        this.props.state.correo_electronico != null
                          ? this.props.state.correo_electronico
                          : ""
                      }
                      onChange={(e) =>
                        this.props.component.handleCorreoElectronicoChange(e)
                      }
                      className="form-control"
                      id="correo_electronico"
                      placeholder="Correo electrónico"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="correo_electronico-error"
                    ></div>
                  </div>
                </div>
              </div>
              {this.props.state.info_encuesta.id === "3" ? (
                <>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="hora_atencion_inicio">
                          Hora de atención inicial:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="time"
                          name="hora_atencion_inicio"
                          onChange={(e) =>
                            this.props.component.handleHoraInicioChange(e)
                          }
                          value={this.props.state.hora_atencion_inicio}
                          className="form-control"
                          id="hora_atencion_inicio"
                          placeholder="Hora de atención inicial"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="hora_atencion_inicio-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="hora_atencion_final">
                          Hora de atención final:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="time"
                          name="hora_atencion_final"
                          onChange={(e) =>
                            this.props.component.handleHoraFinalChange(e)
                          }
                          className="form-control"
                          value={this.props.state.hora_atencion_final}
                          id="hora_atencion_final"
                          placeholder="Hora de atención final"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="hora_atencion_final-error"
                        ></div>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              <div className="row">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="nombre_receptor">
                      Nombre de quien recibe la inspección:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      id="nombre_receptor"
                      name="nombre_receptor"
                      value={
                        this.props.state.nombre_receptor != null
                          ? this.props.state.nombre_receptor
                          : ""
                      }
                      onChange={(e) =>
                        this.props.component.handleNombreReceptorChange(e)
                      }
                      className="form-control"
                      placeholder="Nombre de la persona que recibe la inspección"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="nombre_receptor-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="cargo_receptor">
                      Cargo de quien recibe la inspección:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      id="cargo_receptor"
                      name="cargo_receptor"
                      value={
                        this.props.state.cargo_receptor != null
                          ? this.props.state.cargo_receptor
                          : ""
                      }
                      onChange={(e) =>
                        this.props.component.handleCargoReceptorChange(e)
                      }
                      className="form-control"
                      placeholder="Cargo de la persona que recibe la inspección"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="cargo_receptor-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="lugar">
                      Lugar: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="lugar"
                      value={
                        this.props.state.lugar != null
                          ? this.props.state.lugar
                          : ""
                      }
                      onChange={(e) =>
                        this.props.component.handleLugarChange(e)
                      }
                      className="form-control"
                      id="lugar"
                      placeholder="Lugar"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="lugar-error"
                    ></div>
                  </div>
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    {/* <label>Representante legal: </label>
                <span className="text-danger"> *</span> */}
                    <div
                      id="listaRepresentantes"
                      className={
                        this.props.state.representantes_legales.length > 0
                          ? ""
                          : "hide"
                      }
                    >
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Representantes legales</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.representantes_legales.map(
                            (item) => (
                              <tr key={item.id}>
                                <td>
                                  {item.apellido_materno
                                    ? `${item.nombres} ${item.apellido_paterno} ${item.apellido_materno}`
                                    : `${item.nombres} ${item.apellido_paterno}`}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    {/* <label>Representante legal: </label>
                <span className="text-danger"> *</span> */}
                    <div
                      id="listaRegentes"
                      className={
                        this.props.state.regentes.length > 0 ? "" : "hide"
                      }
                    >
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Regentes</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.regentes.map((item) => (
                            <tr key={item.id}>
                              <td>
                                {item.apellido_materno
                                  ? `${item.nombres} ${item.apellido_paterno} ${item.apellido_materno}`
                                  : `${item.nombres} ${item.apellido_paterno}`}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          {this.props.state.info_encuesta.id === "3" &&
          this.props.state.establecimiento_registrado ? (
            <>
              <h5>REGENTE</h5>
              <fieldset className="panel">
                <legend>A) Seleccionar regente</legend>

                <div className="container">
                  {/* {this.props.state.regentesV.length > 0 ? ( */}
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="regente">
                          Regente: <span className="text-danger"> *</span>
                        </label>

                        <select
                          name="regente"
                          id="regente"
                          value={
                            this.props.state.regente != null
                              ? this.props.state.regente
                              : ""
                          }
                          onChange={(e) =>
                            this.props.component.handleRegenteVChange(e)
                          }
                          className="form-control"
                        >
                          <option value="" disabled>
                            Seleccione
                          </option>
                          {this.props.state.regentesV.map((option) => (
                            <option
                              key={option.id}
                              value={option.id}
                              data-codigo_ipsa={option.codigo_ipsa}
                              data-correo_electronico={
                                option.correo_electronico
                              }
                              data-folio_licencia={option.folio_licencia}
                              data-folio_regente={option.folio_regente}
                              data-fecha_vencimiento={option.fecha_vencimiento}
                            >
                              {option.apellido_materno
                                ? `${option.nombres} ${option.apellido_paterno} ${option.apellido_materno}`
                                : `${option.nombres} ${option.apellido_paterno}`}
                            </option>
                          ))}
                        </select>
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="regente-error"
                        ></div>
                      </div>
                    </div>
                  </div>
                  {/* ) : (
                  null
                )} */}
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="no_licencia_disaan">
                          Número de licencia DISAAN:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          readOnly
                          type="text"
                          name="no_licencia_disaan"
                          value={
                            this.props.state.no_licencia_disaan != null
                              ? this.props.state.no_licencia_disaan
                              : ""
                          }
                          className="form-control"
                          id="no_licencia_disaan"
                          placeholder="Número de licencia DISAAN"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="no_licencia_disaan-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="fecha_vencimiento">
                          Fecha de vencimiento:{" "}
                          <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="date"
                          readOnly
                          value={
                            this.props.state.fecha_vencimiento != null
                              ? this.props.state.fecha_vencimiento
                              : ""
                          }
                          name="fecha_vencimiento"
                          id="fecha_vencimiento"
                          className="form-control"
                          placeholder="Fecha de vencimiento"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="fecha_vencimiento-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="num_regente">
                          Código de regente:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          value={
                            this.props.state.num_regente != null
                              ? this.props.state.num_regente
                              : ""
                          }
                          name="num_regente"
                          readOnly
                          id="num_regente"
                          className="form-control"
                          placeholder="Código de regente"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="num_regente-error"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="form-group">
                        <label htmlFor="correo_electronico_regente">
                          Correo electrónico de regente:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="email"
                          value={
                            this.props.state.correo_electronico_regente != null
                              ? this.props.state.correo_electronico_regente
                              : ""
                          }
                          onChange={(e) =>
                            this.props.component.handleCorreoElectronicoRegenteChange(
                              e
                            )
                          }
                          name="correo_electronico_regente"
                          className="form-control"
                          id="correo_electronico_regente"
                          placeholder="Correo electrónico de regente"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="correo_electronico_regente-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <label htmlFor="presencia_regente">
                        ¿Está presente el regente?:{" "}
                        <span className="text-danger"> *</span>
                      </label>

                      <div className="form-group" id="regente_presente">
                        <div className="form-check form-check-inline">
                          <input
                            id="presente_regente_si"
                            className="form-check-input"
                            type="radio"
                            name="presente_regente"
                            onChange={(e) =>
                              this.props.component.handleRegentePresenteChange(
                                e
                              )
                            }
                            value="1"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="presencia_regente_si"
                          >
                            Sí
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            onChange={(e) =>
                              this.props.component.handleRegentePresenteChange(
                                e
                              )
                            }
                            name="presente_regente"
                            id="presente_regente_no"
                            value="0"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="presente_regente_no"
                          >
                            No
                          </label>
                        </div>
                      </div>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="regente_presente-error"
                      ></div>
                    </div>
                    {/* <div className="col-lg-4">
                    <label htmlFor="vigencia_registro_viegente">
                      ¿El registro del regente, se encuentra vigente?:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <div className="form-group" id="regente_vigente">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          onChange={(e) =>
                            this.props.component.handleRegenteVigenteChange(e)
                          }
                          name="vigencia_registro_regente"
                          id="vigencia_registro_regente_si"
                          value="1"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="vigencia_registro_regente_si"
                        >
                          Sí
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          onChange={(e) =>
                            this.props.component.handleRegenteVigenteChange(e)
                          }
                          name="vigencia_registro_regente"
                          id="vigencia_registro_regente_no"
                          value="0"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="vigencia_registro_regente_no"
                        >
                          No
                        </label>
                      </div>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="regente_vigente-error"
                      ></div>
                    </div>
                  </div> */}
                  </div>
                </div>
              </fieldset>
            </>
          ) : null}

          {this.props.state.tipo_encuesta === "3" ? (
            <h5>TIPO DE INSPECCIÓN</h5>
          ) : this.props.state.tipo_encuesta === "2" ? (
            <h5>2. CARACTERIZACIÓN DE LA INSPECCIÓN</h5>
          ) : null}
          <fieldset className="panel">
            <legend>
              {this.props.state.tipo_encuesta !== "1"
                ? "A) Inspección"
                : "B) Inspección"}{" "}
            </legend>

            <div className="container">
              <div className="row">
                <div
                  className={
                    this.props.state.tipo_encuesta !== "3"
                      ? "col-lg-6"
                      : "col-lg-12"
                  }
                >
                  <div className="form-group">
                    <label htmlFor="fecha_inspeccion">
                      Fecha de inspección:{" "}
                      <span className="text-danger"> *</span>
                    </label>

                    <input
                      type="date"
                      name="fecha_inspeccion"
                      onChange={(e) =>
                        this.props.component.handleFechaInspeccionChange(e)
                      }
                      id="fecha_inspeccion"
                      value={this.props.state.fecha_inspeccion}
                      className="form-control"
                      placeholder="Fecha de inspección"
                    />
                  </div>
                </div>
                <div
                  className={
                    this.props.state.tipo_encuesta === "3"
                      ? "col-lg-12"
                      : "col-lg-6"
                  }
                >
                  <div className="form-group">
                    <label htmlFor="tipo_inspeccion">
                      Tipo de inspección:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="tipo_inspeccion"
                      id="tipo_inspeccion"
                      onChange={(e) =>
                        this.props.component.handleTipoInspeccionChange(e)
                      }
                      className="form-control"
                      value={
                        this.props.state.tipo_inspeccion != null
                          ? this.props.state.tipo_inspeccion
                          : ""
                      }
                      placeholder="Seleccione"
                    >
                      <option value="" disabled>
                        Seleccione
                      </option>
                      {this.props.state.cat_tipo_inspeccion.map((cti) => (
                        <option key={cti.id} value={cti.id}>
                          {cti.descripcion.toUpperCase()}
                        </option>
                      ))}
                    </select>
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="tipo_inspeccion-error"
                    ></div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div
                  className={
                    this.props.state.ultima_fecha_inspeccion
                      ? "col-lg-6"
                      : "col-lg-12"
                  }
                >
                  <div className="form-group">
                    <label htmlFor="inspectores">
                      Inspector(es): <span className="text-danger"> *</span>
                    </label>
                    <Select
                      isMulti
                      id="inspectores"
                      name="inspectores"
                      styles={colourStyles}
                      placeholder="Seleccione"
                      onChange={(e) =>
                        this.props.component.handleInspectoresChange(e)
                      }
                      value={
                        this.props.state.inspectores !== null ||
                        this.props.state.inspectores !== ""
                          ? this.props.state.inspectores
                          : { label: "Seleccione", key: "0" }
                      }
                      theme="neutral40"
                      options={this.props.state.cat_inspectores}
                      getOptionLabel={(inspector) =>
                        inspector.inspector_nombre.toUpperCase()
                      }
                      getOptionValue={(inspector) => inspector.id}
                      noOptionsMessage={() =>
                        "No se encontraron más inspectores"
                      }
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="inspectores-error"
                    ></div>
                  </div>
                </div>

                {this.props.state.ultima_fecha_inspeccion != null ? (
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="ultima_fecha_inspeccion">
                        Última fecha de inspección:{" "}
                        <span className="text-danger"> *</span>
                      </label>

                      <input
                        type="date"
                        name="ultima_fecha_inspeccion"
                        readOnly
                        id="ultima_fecha_inspeccion"
                        value={this.props.state.ultima_fecha_inspeccion}
                        className="form-control"
                        placeholder="Última fecha de inspección"
                      />
                    </div>
                  </div>
                ) : null}
              </div>
              {this.props.state.recomendaciones_anteriores ? (
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label htmlFor="recomendaciones_anteriores">
                        Breve descripción de recomendaciones anteriores:
                      </label>
                      <textarea
                        readOnly
                        className="form-control"
                        id="recomendaciones_anteriores"
                        value={this.props.state.recomendaciones_anteriores}
                        placeholder="recomendaciones anteriores"
                        name="recomendaciones_anteriores"
                      ></textarea>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.props.state.observaciones_anteriores ? (
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label htmlFor="observaciones_anteriores">
                        Breve descripción de observaciones anteriores:
                      </label>
                      <textarea
                        readOnly
                        className="form-control"
                        id="observaciones_anteriores"
                        value={this.props.state.observaciones_anteriores}
                        placeholder="Observaciones anteriores"
                        name="observaciones_anteriores"
                      ></textarea>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </fieldset>

          {this.props.state.tipo_encuesta === "2" ? (
            <h5>3. TIPO DE PRODUCCIÓN</h5>
          ) : null}
          {this.props.state.tipo_encuesta !== "3" ? (
            <fieldset className="panel">
              <legend>
                {this.props.state.tipo_encuesta === "1"
                  ? "C) Caracterización de la producción"
                  : this.props.state.tipo_encuesta === "2"
                  ? "A) Producción"
                  : null}
              </legend>

              <div className="container">
                <div className="row">
                  {this.props.state.tipo_encuesta === "1" ? (
                    <div
                      className={
                        this.props.state.tipo_encuesta === "1" ||
                        this.props.state.tipo_encuesta === "2"
                          ? "col-lg-4"
                          : "col-lg-6"
                      }
                    >
                      <div className="form-group">
                        <label htmlFor="destino_produccion">
                          Destino de la producción:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          isMulti
                          id="destino_produccion"
                          value={
                            this.props.state.destino_produccion !== null ||
                            this.props.state.destino_produccion !== ""
                              ? this.props.state.destino_produccion
                              : { label: "Seleccione", key: "0" }
                          }
                          styles={colourStyles}
                          placeholder="Seleccione"
                          onChange={(e) =>
                            this.props.component.handleDestinoProduccionChange(
                              e
                            )
                          }
                          theme="neutral40"
                          options={this.props.state.cat_tipo_produccion}
                          getOptionLabel={(produccion) =>
                            produccion.descripcion.toUpperCase()
                          }
                          getOptionValue={(produccion) => produccion.id}
                          noOptionsMessage={() =>
                            "No se encontraron más tipo de producción"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="destino_produccion-error"
                        ></div>
                      </div>
                    </div>
                  ) : null}
                  {this.props.state.tipo_encuesta !== "2" ? (
                    <div
                      className={
                        this.props.state.tipo_encuesta === "1"
                          ? "col-lg-4"
                          : "col-lg-6"
                      }
                    >
                      <div className="form-group">
                        <label htmlFor="tipo_especie">
                          Especies de destino:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          isMulti
                          id="tipo_especie"
                          value={
                            this.props.state.tipo_especie !== null ||
                            this.props.state.tipo_especie !== ""
                              ? this.props.state.tipo_especie
                              : { label: "Seleccione", key: "0" }
                          }
                          styles={colourStyles}
                          placeholder="Seleccione"
                          onChange={(e) =>
                            this.props.component.handleTipoEspecieChange(e)
                          }
                          theme="neutral40"
                          options={this.props.state.cat_especies}
                          getOptionLabel={(especie) =>
                            especie.descripcion.toUpperCase()
                          }
                          getOptionValue={(especie) => especie.id}
                          noOptionsMessage={() =>
                            "No se encontraron más especies de destino"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="tipo_especie-error"
                        ></div>
                      </div>
                    </div>
                  ) : null}
                  {this.props.state.tipo_encuesta === "1" ? (
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="materia_prima">
                          Materia prima: <span className="text-danger"> *</span>
                        </label>
                        <Select
                          isMulti
                          id="materia_prima"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          value={
                            this.props.state.materia_prima !== null ||
                            this.props.state.materia_prima !== ""
                              ? this.props.state.materia_prima
                              : { label: "Seleccione", key: "0" }
                          }
                          onChange={(e) =>
                            this.props.component.handleMateriaPrimaChange(e)
                          }
                          theme="neutral40"
                          options={this.props.state.cat_materia_prima}
                          getOptionLabel={(materia_prima) =>
                            materia_prima.descripcion.toUpperCase()
                          }
                          getOptionValue={(materia_prima) => materia_prima.id}
                          noOptionsMessage={() =>
                            "No se encontraron más materia prima"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="materia_prima-error"
                        ></div>
                      </div>
                    </div>
                  ) : this.props.state.tipo_encuesta === "2" ? (
                    <>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="tipo_produccion">
                            Tipo de producción:{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            isMulti
                            id="destino_produccion"
                            styles={colourStyles}
                            placeholder="Seleccione"
                            value={
                              this.props.state.destino_produccion !== null ||
                              this.props.state.destino_produccion !== ""
                                ? this.props.state.destino_produccion
                                : { label: "Seleccione", key: "0" }
                            }
                            onChange={(e) =>
                              this.props.component.handleDestinoProduccionChange(
                                e
                              )
                            }
                            theme="neutral40"
                            options={this.props.state.cat_tipo_produccion}
                            getOptionLabel={(produccion) =>
                              produccion.descripcion.toUpperCase()
                            }
                            getOptionValue={(produccion) => produccion.id}
                            noOptionsMessage={() =>
                              "No se encontraron más tipo de producción"
                            }
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="destino_produccion-error"
                          ></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="materia_prima">
                            Materia prima:{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            isMulti
                            id="materia_prima"
                            styles={colourStyles}
                            placeholder="Seleccione"
                            value={
                              this.props.state.materia_prima !== null ||
                              this.props.state.materia_prima !== ""
                                ? this.props.state.materia_prima
                                : { label: "Seleccione", key: "0" }
                            }
                            onChange={(e) =>
                              this.props.component.handleMateriaPrimaChange(e)
                            }
                            theme="neutral40"
                            options={this.props.state.cat_materia_prima}
                            getOptionLabel={(materia_prima) =>
                              materia_prima.descripcion.toUpperCase()
                            }
                            getOptionValue={(materia_prima) => materia_prima.id}
                            noOptionsMessage={() =>
                              "No se encontraron más materia prima"
                            }
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="materia_prima-error"
                          ></div>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>

                {this.props.state.tipo_encuesta === "1" ? (
                  <>
                    <div className="row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="volumen_semanal">
                            Volumen producido semanal:{" "}
                          </label>
                          <input
                            type="number"
                            min="0"
                            max="99999.99"
                            step=".01"
                            onChange={(e) =>
                              this.props.component.handleVolumenSemanalChange(e)
                            }
                            value={
                              this.props.state.volumen_semanal != null
                                ? this.props.state.volumen_semanal
                                : ""
                            }
                            name="volumen_semanal"
                            id="volumen_semanal"
                            className="form-control"
                            placeholder="Volumen semanal"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="volumen_semanal-error"
                          ></div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="volumen_mensual">
                            Volumen producido mensual:{" "}
                          </label>
                          <input
                            type="number"
                            min="0"
                            max="99999.99"
                            step=".01"
                            onChange={(e) =>
                              this.props.component.handleVolumenMensualChange(e)
                            }
                            name="volumen_mensual"
                            id="volumen_mensual"
                            value={
                              this.props.state.volumen_mensual != null
                                ? this.props.state.volumen_mensual
                                : ""
                            }
                            className="form-control"
                            placeholder="Volumen mensual"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="volumen_mensual-error"
                          ></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="porc_exp_nica">
                            Porcentaje que representa la exportación a
                            Nicaragua:{" "}
                          </label>
                          <div className="input-group">
                            <input
                              id="porc_exp_nica"
                              type="number"
                              min="0"
                              max="100"
                              step=".01"
                              value={
                                this.props.state.porc_exp_nica != null
                                  ? this.props.state.porc_exp_nica
                                  : ""
                              }
                              onChange={(e) =>
                                this.props.component.handlePorcentajeExportacionChange(
                                  e
                                )
                              }
                              name="porc_exp_nica"
                              className="form-control"
                              placeholder="Porcentaje de exportación"
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                id="porcentaje"
                              >
                                %
                              </span>
                            </div>
                            <div
                              className="invalid-feedback"
                              style={{ display: "none" }}
                              id="porc_exp_nica-error"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </fieldset>
          ) : null}

          {this.props.state.tipo_encuesta === "2" ? (
            <>
              <h5>4. TIPO DE PRODUCTO</h5>
              <fieldset className="panel">
                <legend>A) PRODUCTO</legend>

                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="tipo_subproducto">
                          Tipo de producto:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          isMulti
                          id="tipo_subproducto"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          onChange={(e) =>
                            this.props.component.handleTipoSubproductoChange(e)
                          }
                          value={
                            this.props.state.tipo_subproducto !== null ||
                            this.props.state.tipo_subproducto !== ""
                              ? this.props.state.tipo_subproducto
                              : { label: "Seleccione", key: "0" }
                          }
                          theme="neutral40"
                          options={this.props.state.cat_tipo_subproducto}
                          getOptionLabel={(subproducto) =>
                            subproducto.descripcion.toUpperCase()
                          }
                          getOptionValue={(subproducto) => subproducto.id}
                          noOptionsMessage={() =>
                            "No se encontraron más tipo de productos"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="tipo_subproducto-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="tipo_especie">
                          Especies de destino:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          isMulti
                          id="tipo_especie"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          onChange={(e) =>
                            this.props.component.handleTipoEspecieChange(e)
                          }
                          theme="neutral40"
                          value={
                            this.props.state.tipo_especie !== null ||
                            this.props.state.tipo_especie !== ""
                              ? this.props.state.tipo_especie
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_especies}
                          getOptionLabel={(especie) =>
                            especie.descripcion.toUpperCase()
                          }
                          getOptionValue={(especie) => especie.id}
                          noOptionsMessage={() =>
                            "No se encontraron más especies de destino"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="tipo_especie-error"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </>
          ) : null}
        </div>

        {/* encuesta */}
        {this.props.state.info_encuesta.id === "1" ? (
          <h5>2. REQUISITOS MÍNIMOS SANITARIOS Y DE BPM A VERIFICAR</h5>
        ) : this.props.state.info_encuesta.id === "3" ? (
          <h5>INSPECCIÓN DEL ESTABLECIMIENTO</h5>
        ) : (
          <h5>5. REQUISITOS SANITARIOS Y DE BPM</h5>
        )}

        <div style={{ textAlign: "right" }}>
          <h6>
            {!["3", "11", "12"].includes(this.props.state.tipo_encuesta)
              ? "C.=Conforme N.C.=No conforme N.A.=No aplica N.V.=No verificado"
              : "C.=Conforme N.C.=No conforme N.A.=No aplica"}
          </h6>
        </div>

        {this.props.state.quizzes.map((item) => {
          return (
            <EncuestaTipo1
              key={item.id}
              quizz={item}
              respuestas={this.props.state.questions}
              establecimiento_id={this.props.state.establecimiento_id}
              encuesta_id={this.props.state.tipo_encuesta}
              handleRadioEncuestaChange={(e) =>
                this.props.component.handleRadioEncuestaChange(e)
              }
              handleTextAreaEncuestaChange={(e) =>
                this.props.component.handleTextAreaEncuestaChange(e)
              }
            />
          );
        })}

        <fieldset className="panel">
          <legend>Recomendaciones</legend>
          <div className="container">
            <div className="form-group">
              <textarea
                // onChange={(e) =>
                //   this.setState({ recomendaciones: e.target.value })
                // }
                onChange={(e) =>
                  this.props.component.handleRecomendacionesChange(e)
                }
                className="form-control"
                value={this.props.state.recomendaciones}
                placeholder="Recomendaciones"
                name="recomendaciones"
              ></textarea>
            </div>
          </div>
        </fieldset>
        <fieldset className="panel">
          <legend>Observaciones adicionales</legend>
          <div className="container">
            <div className="form-group">
              <textarea
                onChange={(e) =>
                  this.props.component.handleObservacionesChange(e)
                }
                className="form-control"
                placeholder="Observaciones"
                value={this.props.state.observaciones}
                name="observaciones"
              ></textarea>
            </div>
          </div>
        </fieldset>
        <fieldset className="panel">
          <legend>Dictamen de sanción</legend>
          <div className="container">
            <div className="form-group">
              <FormControlLabel
                label="Sancionar establecimiento"
                control={
                  <Checkbox
                    checked={this.props.state.establecimiento_sancionado}
                    onChange={(e) =>
                      this.props.component.handleSancionEstablecimientoCBChange(
                        e
                      )
                    }
                    style={{ color: "#fff" }}
                    name="checkedB"
                    color="primary"
                  />
                }
              />
            </div>
          </div>
        </fieldset>
        <hr />
        <button type="submit" className="btn btn-success btn-block">
          Guardar
        </button>
      </>
    );
  }
}

export default VisitaGrupo1;
